/**
 * Calculates difference in years given date. Optionally endDate
 * can be provided to calculate to at a specific date
 *
 * @see https://stackoverflow.com/a/35302332
 * @param string|Date Object startDate
 * @param string|Date Object endDate optional
 * @returns integer years between start date and a given end date or today
 */
 const dateDifference = (startDate, endDate) => {
    if (Object.prototype.toString.call(startDate) !== '[object Date]') {
        startDate = new Date(startDate);
    }

    if (typeof endDate == "undefined") {
        endDate = new Date();
    } else if (Object.prototype.toString.call(endDate) !== '[object Date]') {
        endDate = new Date(endDate);
    }

    if (endDate == null || startDate == null) {
        return '';
    }

    let monthsDifference = endDate.getMonth() - startDate.getMonth();
  
    // answer: end date year minus start date year less one (1) if month and day of
    // end date year is before month and start date year
    return endDate.getFullYear() - startDate.getFullYear() - (
        (monthsDifference < 0 || (monthsDifference === 0 && endDate.getDate() < startDate.getDate())
    ) ? 1 : 0);
}

const getDriverAge = driver => {
    let age = 0;
    if (driver && (
        'dateOfBirth' in driver._source || 
        'yearOfBirth' in driver._source || 
        'yearOfBirthCirca' in driver._source
    )) {
        let driverDob = new Date();
        if (driver._source.dateOfBirth !== undefined && 
            driver._source.dateOfBirth !== null && 
            driver._source.dateOfBirth !== ''
        ) {
            driverDob = formatAsDate(driver._source.dateOfBirth);
        } else if (
            driver._source.yearOfBirth !== undefined && 
            driver._source.yearOfBirth !== null && 
            driver._source.yearOfBirth !== ''
        ) {
            driverDob = new Date(driver._source.yearOfBirth, 0, 1);
        } else if (
            driver._source.yearOfBirthCirca !== undefined && 
            driver._source.yearOfBirthCirca !== null && 
            driver._source.yearOfBirthCirca !== ''
        ) {
            driverDob = new Date(driver._source.yearOfBirthCirca, 0, 1);
        }

        let driverDod = new Date();
        if (driver._source.dateOfDeath !== undefined && 
            driver._source.dateOfDeath !== null && 
            driver._source.dateOfDeath !== ''
        ) {
            driverDod = formatAsDate(driver._source.dateOfDeath);
        } else if (
            driver._source.yearOfDeath !== undefined && 
            driver._source.yearOfDeath !== null && 
            driver._source.yearOfDeath !== ''
        ) {
            driverDod = new Date(driver._source.yearOfDeath, 0, 1);
        } else if (
            driver._source.yearOfDeathCirca !== undefined && 
            driver._source.yearOfDeathCirca !== null && 
            driver._source.yearOfDeathCirca !== ''
        ) {
            driverDod = new Date(driver._source.yearOfDeathCirca, 0, 1);
        }

        age = dateDifference(driverDob, driverDod);
    }

    return age > 0 ? age : '';
};

const getDriverYearsRaced = driver => {
    let yearsRaced = 'Unknown';

    if ('yearsRaced' in driver._source && driver._source.yearsRaced !== '') {
        yearsRaced = driver._source.yearsRaced;
    } else if ('recentRaceDate' in driver._source && 
        driver._source.recentRaceDate !== '' && 
        'dateOfFirstRace' in driver._source &&
        driver._source.dateOfFirstRace !== ''
    ) {
        let recentRaceDate = formatAsDate(driver._source.recentRaceDate).getFullYear();
        let dateOfFirstRace = formatAsDate(driver._source.dateOfFirstRace).getFullYear();
        yearsRaced = recentRaceDate == dateOfFirstRace
            ? 1
            : recentRaceDate - dateOfFirstRace;
    } else if ('dateOfFirstRace' in driver._source && driver._source.dateOfFirstRace !== '') {
        let recentRaceDate = new Date().getFullYear();
        let dateOfFirstRace = formatAsDate(driver._source.dateOfFirstRace).getFullYear();
        yearsRaced = recentRaceDate == dateOfFirstRace
            ? 1
            : recentRaceDate - dateOfFirstRace;
    } 

    return yearsRaced;
};

const getTeamYearsRaced = team => {
    let yearsRaced = 'Unknown';

    if ('yearsRaced' in team._source && team._source.yearsRaced !== '') {
        yearsRaced = team._source.yearsRaced;
    } else if ('latestRaceDate' in team._source && 
        team._source.latestRaceDate !== '' &&
        'dateOfFirstRace' in team._source &&
        team._source.dateOfFirstRace != ''
    ) {
        let latestRaceDate = formatAsDate(team._source.latestRaceDate).getFullYear();
        let dateOfFirstRace = formatAsDate(team._source.dateOfFirstRace).getFullYear();
        yearsRaced = latestRaceDate == dateOfFirstRace
            ? 1
            : latestRaceDate - dateOfFirstRace;
    } else if ('dateOfFirstRace' in team._source && team._source.dateOfFirstRace != '') {
        let latestRaceDate = new Date().getFullYear();
        let dateOfFirstRace = formatAsDate(team._source.dateOfFirstRace).getFullYear();
        yearsRaced = latestRaceDate == dateOfFirstRace
            ? 1
            : latestRaceDate - dateOfFirstRace;
    } 

    return yearsRaced;
};

const getOrdinal = dayNum => {
    const ordinals = ['th', 'st', 'nd', 'rd'];
    const value = dayNum % 100;

    return dayNum + (ordinals[(value - 20) % 10] || ordinals[value] || ordinals[0]);
};

const getFormattedDriverDOB = (driver, shortDate = false) => {
    let dateOfBirth = '';

    if (driver && (
        'dateOfBirth' in driver._source || 
        'yearOfBirth' in driver._source || 
        'yearOfBirthCirca' in driver._source
    )) {
        if (driver._source.dateOfBirth !== undefined && 
            driver._source.dateOfBirth !== null && 
            driver._source.dateOfBirth !== ''
        ) {
            if (shortDate) {
                dateOfDeath = getFormatedDate(driver._source.dateOfBirth);
            } else {
                const dobDate = formatAsDate(driver._source.dateOfBirth);
                const months = [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                ];
                dateOfBirth = `${getOrdinal(dobDate.getDate())} ${months[dobDate.getMonth()]} ${dobDate.getFullYear()}`;
            }
        } else if (
            driver._source.yearOfBirth !== undefined && 
            driver._source.yearOfBirth !== null && 
            driver._source.yearOfBirth !== ''
        ) {
            dateOfBirth = driver._source.yearOfBirth;
        } else if (driver._source.yearOfBirthCirca !== undefined && driver._source.yearOfBirthCirca !== null && driver._source.yearOfBirthCirca !== '') {
            dateOfBirth = `CIRCA ${driver._source.yearOfBirthCirca}`;
        }
    }

    return dateOfBirth;
};

const getFormattedDriverDOD = (driver, shortDate = false) => {
    let dateOfDeath = '';

    if (driver && (
        'dateOfDeath' in driver._source || 
        'yearOfDeath' in driver._source || 
        'yearOfDeathCirca' in driver._source)
    ) {
        if (driver._source.dateOfDeath !== undefined && 
            driver._source.dateOfDeath !== null && 
            driver._source.dateOfDeath !== ''
        ) {
            if (shortDate) {
                dateOfDeath = getFormatedDate(driver._source.dateOfDeath);
            } else {
                const dodDate = formatAsDate(driver._source.dateOfDeath);
                const months = [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                ];
                dateOfDeath = `${getOrdinal(dodDate.getDate())} ${months[dodDate.getMonth()]} ${dodDate.getFullYear()}`;
            }
        } else if (
            driver._source.yearOfDeath !== undefined && 
            driver._source.yearOfDeath !== null && 
            driver._source.yearOfDeath !== ''
        ) {
            dateOfDeath = driver._source.yearOfDeath;
        } else if (
            driver._source.yearOfDeathCirca !== undefined && 
            driver._source.yearOfDeathCirca !== null && 
            driver._source.yearOfDeathCirca !== ''
        ) {
            dateOfDeath = `CIRCA ${driver._source.yearOfDeathCirca}`;
        }
    }

    return dateOfDeath;
};

const getFormatedDate = dateStr => {
    dateStr = formatAsDate(dateStr);
    return `${dateStr.getDate().toString().padStart(2, '0')}/${(parseInt(dateStr.getMonth()) + 1).toString().padStart(2, '0')}/${dateStr.getFullYear()}`;
};

const formatAsDate = dateStr => {
    if (dateStr === undefined) {
        return new Date();
    }

    return new Date(Date.parse(dateStr.replace(/-/g, '/')));
};

const getRaceWinners = race => {
    let winners = [];

    if ('raceWinners' in race._source) {
        race._source.raceWinners.forEach(winner => {
            if ('driver' in winner) {
                winners.push({
                    name: winner.driver,
                    url: '',
                    css_class: 'database-table__title'
                });
            }
        });

        if (race._source.raceWinners[0] && 'team' in race._source.raceWinners[0]) {
            winners.push({
                name: race._source.raceWinners[0].team_entrant !== ''
                    ? race._source.raceWinners[0].team_entrant
                    : race._source.raceWinners[0].team,
                url: '',
                css_class: 'database-table__subtitle proxima'
            });
        }
    }

    return winners;
};

export { getDriverAge, getDriverYearsRaced, getTeamYearsRaced, getFormattedDriverDOB, getFormattedDriverDOD, getRaceWinners, formatAsDate, getFormatedDate };
